import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { UserAuthService } from "@app/user/user-core/services/user-auth.service";
import { LocationProvider } from "@helper/abstraction/providers";
import { UserProfile } from "@helper/abstraction/user";
import { Observable } from "rxjs";
import { first } from "rxjs/operators";

const TOKEN_KEY = "token.user.v1";
export interface BannerDto {
  bannerId: string;
  html: string;
  css: string;
}

@Injectable()
export class BannerService {
  private url = "https://test0.vls.dcby.xyz/api/analytics/api/v1/banners";
  private prodUrl = "https://www.bidmart.by/api/analytics/api/v1/banners";
  private profile?: UserProfile;

  constructor(private httpClient: HttpClient, private readonly inj: Injector) {
    const auth = this.inj.get(UserAuthService);
    auth.userProfile$.pipe(first(),).subscribe(profile => this.profile = profile);
  }

  public getBanner(app: string, location: string, profile?: UserProfile): Observable<BannerDto> {
    const url = `${this.providerLocation() === "PROD" ? this.prodUrl : this.url}`;
    const params = new HttpParams().set('app', app).set('banner_location', location);
    const token = localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
    const headers = new HttpHeaders({
      'Authorization': token!,
      'X-EDI-User-Id': profile?.userId?.toString()!
    });

    return this.httpClient.get<BannerDto>(url, { headers, params, withCredentials: true });
  }

  public click(bannerId: string): Observable<any> {
    const url = `${this.providerLocation() === "PROD" ? this.prodUrl : this.url}/${encodeURIComponent(bannerId)}/click`;
    const token = localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
    let headers = new HttpHeaders({
      'Authorization': token!,
      'X-EDI-User-Id': this.profile?.userId?.toString()!
    });
  
    return this.httpClient.post(url, null, { headers, withCredentials: true });
  }

  public close(bannerId: string): Observable<any> {
    const url = `${this.providerLocation() === "PROD" ? this.prodUrl : this.url}/${encodeURIComponent(bannerId)}/close`;
    const token = localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
    let headers = new HttpHeaders({
      'Authorization': token!,
      'X-EDI-User-Id': this.profile?.userId?.toString()!
    });
  
    return this.httpClient.post(url, null, { headers, withCredentials: true });
  }

	private providerLocation(): LocationProvider {
		let locationContour: LocationProvider;
		switch (window.location.host) {
			case "edi.bidmart.by":
				locationContour = "PROD";
				break;
			default:
				locationContour = "DEV";
				break;
		}
		return locationContour;
	}
}
